

















































































import axios from 'axios'
import {Component, Emit, Prop, Watch} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import {Medium} from '@/models/Medium'
import {apiV1AdminMediaPath, apiV1AdminMediumPath} from '@/rails/routes'
import Post from '@/models/Post'
import {Vue} from 'vue/types/vue'
import * as dayjs from 'dayjs'

@Component
export default class MediaSelector extends VueBase {
  @Prop({ type: Boolean, default: true }) readonly selector!: boolean
  @Prop({ type: Object }) readonly post: Post
  @Prop({ type: Boolean, default: false }) readonly multiple!: boolean
  @Emit()
  onSelect(): Medium | Array<Medium> {
    return this.multiple ? this.selected : this.selected[0]
  }
  @Emit()
  onCancel(): void {}

  page = 0
  files: FileList = null
  showedConfirm = false
  media: Array<Medium> = []
  selected: Array<Medium> = []
  onlySelf = false
  startDateMenu = false
  endDateMenu = false
  startDate = null
  endDate = null

  mounted(): void {
    this.fetch()
  }

  @Watch('onlySelf')
  onChangeOnlySelf(): void {
    this.reset()
    this.fetch()
  }

  async fetch(): Promise<void> {
    this.showLoading()
    this.page++
    const params = {
      page: this.page,
      post_id: null,
      post_type: null,
      startDate: null,
      endDate: null,
    }
    if(this.startDate){
      params.startDate = dayjs(new Date(this.startDate)).format('YYYY-MM-DD')
    }
    if(this.endDate){
      const endDate = new Date(this.endDate)
      endDate.setDate( endDate.getDate() + 1 )
      params.endDate = dayjs(endDate).format('YYYY-MM-DD')
    }
    if (this.onlySelf) {
      params.post_id = this.post.id
      params.post_type = this.post.className
    }
    const media = await axios.get<Array<Medium>>(apiV1AdminMediaPath(params))
    this.media = this.media.concat(media.data.map(m => new Medium(m)))
    this.hideLoading()
  }

  reset(): void {
    this.page = 0
    this.media = []
    this.selected = []
  }

  reload(): void {
    this.reset()
    this.fetch()
  }

  select(medium: Medium): void {
    if (this.selected.includes(medium)) {
      this.selected = this.selected.filter(s => s !== medium)
    } else {
      if (this.multiple) {
        this.selected.push(medium)
      } else {
        this.selected = [medium]
      }
    }
  }

  applyInputFile(): void {
    (this.$refs.fileInput as Vue).$el.querySelector('button').click()
  }

  uploadFiles(): void {
    let uploading = this.files.length
    if (!uploading) {
      return
    }
    this.showLoading()
    this.loadFile(this.files, async (file, e) => {
      await axios.post(apiV1AdminMediaPath(), {
        medium: {
          parent_id: this.post?.id,
          parent_type: this.post?.className,
          content_url: e.target.result,
          content_name: file.name
        }
      })
      uploading--
      if (uploading === 0) {
        this.reload()
        this.hideLoading()
      }
    })
  }

  loadFile(files: FileList, onLoad: (file: File, e: ProgressEvent<FileReader>) => void): void {
    if (files.length) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const fileReader = new FileReader()
        fileReader.onload = (e): void => {
          onLoad(file, e)
        }
        fileReader.readAsDataURL(file)
      }
    }
  }

  async destroy(): Promise<void> {
    await axios.delete(apiV1AdminMediumPath(this.selected[0].id))
    this.showMessage('画像が削除されました')
    this.reload()
    this.showedConfirm = false
  }
}
